export default __webpack_public_path__ + "static/media/crypto-com-logo.97805fe8.png";